import { ExactlyOneOf } from '../../../../../common/custom-field-config/interface/custom-field-detail-config';
import {
  IFileGenerationContext,
  IReferencedFieldFilterConfig
} from '../../../../../common/custom-field-config/interface/custom-field-detail';
import { IDatePropertiesMinMax } from '../../../../../common/custom-field-config/custom-field-type/date-config';
import { IConfigName } from '../../../../../common/field/type/interface/field-type-object';
import { EnumItemsDataSource } from "../../../../document-module/module/form/automation/components/action/filter-enum/enum-items-data-source";

export type FieldsData = { [fieldId: string]: any };

export type FieldFilterInput = FieldsData;

export interface IOptionValue {
  id: string;
  label: string;
  value?: string;
  deleted?: boolean;
}

export interface IDatabaseType {
  companyId: string;
  databaseId: string;
}

export interface IFormType {
  companyId: string;
  formId: string;
}

export interface NameValue {
  label: string;
  value: string;
}

export interface IInputConfig {
  type: string;
  config: IFieldConfig;
  maxItems?: number;
}

export interface IPagination {
  offset: number;
  total: number;
}

export interface IFieldPermission {
  id: string;
  name: string;
}

export enum IFieldAccessType {
  ReadWrite = 'readwrite',
  Readonly = 'readonly',
  Required = 'required',
  Hidden = 'hidden',
}

export enum EnumSelectAllMode {
  None = 'none',
  Automatic = 'automatic',
  Manual = 'manual'
}

export enum EnumExclusiveMode {
  None = 'none',
  Field = 'field'
}

export interface IField {
  id?: string;
  label?: string;
  inputConfig?: IInputConfig;
  configName?: IConfigName;
  accessType?: IFieldAccessType;
  // TODO: Refactor - replace usages with 'configPerRow'
  accessTypePerRow?: IFieldAccessType[];
  configPerRow?: { [rowNumber: number]: IField }
  defaultValue?: any;
  validationSchema?: Object;
  custom?: boolean;
  permission?: IFieldPermission
  searchable?: boolean;
  reloadOnChange?: string[];
  requiresFieldData?: string[];
  hint?: string;
  agg?: string;
  placement?: string;
  flags?: string[];
}

export type IEnumLocalFilter = (option: IOptionValue) => boolean;

export interface IFieldConfig {
  format?: string;
  displayType?: string;
  alignment?: 'left' | 'center' | 'right';
  maxLength?: number;
  minLength?: number;
  max?: number | IDatePropertiesMinMax;
  min?: number | IDatePropertiesMinMax;
  decimals?: number;
  thousandSeparator?: boolean;
  multiselect?: boolean;
  data?: ExactlyOneOf<[IOptionValue[], IDatabaseType, IFormType]>;
  items?: NameValue[] | any;
  dataType?: string;
  labelFormat?: string;
  filter?: IReferencedFieldFilterConfig;
  pagination?: IPagination;
  custom?: boolean;
  columns?: IField[];
  value?: string;
  maxItems?: number;
  type?: string;
  enableCameraInput?: boolean;
  filterEnumOptions?: IEnumLocalFilter;
  dataSource?: EnumItemsDataSource;
  systemGenerated?: boolean;
  generationContext?: IFileGenerationContext;
  from?: IFieldConfig;
  to?: IFieldConfig;
  maxRows?: number;
  minRows?: number;
  sort?: ISortEnumConfig[];
  selectAllMode?: EnumSelectAllMode;
  exclusiveMode?: EnumExclusiveMode;
  showReferenceInSource?: boolean;
  showReferenceInDestination?: boolean;
  style?: IFieldStyle;
}

export interface ISortField {
  fieldId: string;
  sort: string;
  ascending: boolean;
}

export interface ISortEnumConfig {
  key: ISortEnumKey,
  direction: ISortEnumDirection,
}

export enum ISortEnumKey {
  Label = 'label',
  Id = 'id',
  Created_At = 'created_at'
}

export enum ISortEnumDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export interface IFieldStyle {
  minLines?: number;
  maxLines?: number;
}